module.exports = __webpack_public_path__ + "static/img/cont01_family_chart.c84ae18.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sapporo/images/cont01_family_chart.png
// module id = WyWF
// module chunks = 0